<template>
  <div class="page_content change-password-section">
  	
    <div class="row page-heading" v-if="!showInModal">
			<div class="col-7 input module_heading" role="heading" aria-level="1">
				<div class="module_icon icon-user"></div>
				<label class="head_txt module_type_name">Manage your account :: Change Password</label>
			</div>
			<div class="col-5 float-right px-0">
				<div class="btn-container">
				</div>
			</div>
		</div>

		<div class="page-content-section row">
      <b-container fluid>
        <b-row :class="{'margin-top-30': !showInModal}">
          <b-col cols="3" class="description-section" v-if="!showInModal"></b-col>
          <b-col :cols="showInModal ? 12 : 6" class="form-field-section">
            <b-card>
              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="password">Old Password</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model="oldpassword" aria-labelledby="password" placeholder="Old Password" required type="password" />
                </div>
              </div>

              <div class="row field-row message_bar">
                <div class="col-3"></div>
                <div class="col-9 field-column">
                  <p>A strong password contains a mix of numbers, letters, and symbols. It is hard to guess, does not resemble a real word, and is only used for this account.</p>
                </div>
              </div>

              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="newPassword">New Password</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model="newpassword" aria-labelledby="newPassword" placeholder="New Password" required type="password" />
                </div>
              </div>

              <div class="row field-row">
                <div class="col-5 title-column">
                  <label id="reEnterPassword">Re-enter New Password</label>
                </div>
                <div class="col-6 field-column">
                  <input v-model="newpassword2" aria-labelledby="reEnterPassword" placeholder="Re-Enter New Password" required type="password" />
                </div>
              </div>

              <div class="btn-container">
                <button v-on:click="validatePassword" class="btn btn-primary" aria-label="save" :disabled="buttonDisabled">change password</button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>

  </div>
</template>

<script>
import '../../../assets/module/css/user/changePassword.min.css'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'userSettings',
  props: ['uuid', 'showInModal'],
  data: () => {
    return {
      oldpassword: '',
      newpassword: '',
      newpassword2: ''
    }
  },

  mounted () {
    this.loadUserDetail()
  },

  methods: {
    ...mapActions([
      'loadUpdatePassword',
      'loadUser'
    ]),

    loadUserDetail () {
      this.loadUser(this.uuid).then(res => {
      })
    },

    validatePassword () {
      if (this.newpassword !== this.newpassword2) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do not match'
        })
      } else if (this.newpassword.length < 6) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords cannot be less than 6 characters'
        })
      } else {
        this.changePassword()
      }
    },

    changePassword () {
      this.changePassword.userUuid = this.uuid
      this.changePassword.firstName = this.user.firstName
      this.changePassword.lastName = this.user.lastName
      var formData = new FormData()
      formData.append('oldPassword', this.oldpassword)
      formData.append('newPassword', this.newpassword)
      formData.append('userUuid', this.uuid)
      formData.append('firstName', this.user.firstName)
      formData.append('lastName', this.user.lastName)
      this.loadUpdatePassword({data: formData}).then(res => {
        if (res.status === 200) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Password successfully updated!'
          })
          this.reset()
          setTimeout(() => {
            this.$root.$emit('closeChangePasswordModal')
          }, 0)
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please enter correct password!'
          })
          this.reset()
        }
      })
    },

    reset () {
      this.oldpassword = ''
      this.newpassword = ''
      this.newpassword2 = ''
    }

  },

  computed: {
    ...mapState({
      'user': state => state.user.user
    }),
    buttonDisabled () {
      return !(this.oldpassword && this.newpassword && this.newpassword2)
    }
  }
}
</script>
<style>
  .margin-top-10 {
    margin-top: 10px;
  }
  .margin-top-20 {
    margin-top: 20px;
  }
  .margin-top-30 {
    margin-top: 30px;
  }
  .no-border {
    border: none;
  }
  .margin-left-20 {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserSettings.vue